// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2cJnj","inner":"Footer_inner__2NtQH"};